import 'chart.js'
import { ResponsiveBar } from 'nivo'
import * as React from 'react';

interface IBarProps {
  events: any[];
  active: number;
  numEvents: number;
}
class BarGraph extends React.Component<IBarProps> {

  public state = {
    data: []
  }
  public componentWillMount() {
    const arr: any[] = [];
    let i = 1;
    this.props.events.forEach((item) => {
      if (item.isActive) {
        arr.push({
          "index": String(i),
          "Revenue $": Number(item.revenueTotal) / 100
        })
        i++;
      }
    })
    this.setState({ data: arr })
  }

  public render() {
    return (
      <div style={{ paddingRight: '5%', paddingLeft: '5%', width: '100%', height: '400px' }}>
        <p><br /></p>
        <ResponsiveBar
          data={this.state.data}
          keys={['Revenue $']}
          indexBy="index"
          margin={{ top: 40, right: 30, bottom: 50, left: 60 }}
          padding={0.3}
          colors='paired'
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Index',
            legendPosition: 'middle',
            legendOffset: 32
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Revenue $',
            legendPosition: 'middle',
            legendOffset: -40
          }}
          enableLabel={false}
          legends={[
            {
              dataFrom: 'keys',
              anchor: 'bottom-right',
              direction: 'column',
              justify: false,
              translateX: 120,
              translateY: 0,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: 'left-to-right',
              itemOpacity: 0.85,
              symbolSize: 20,
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemOpacity: 1
                  }
                }
              ]
            }
          ]}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
        />
      </div>
    );
  }
}

export default BarGraph;



// WEBPACK FOOTER //
// ./src/pages/dashboard/BarGraph.tsx